module.exports = __webpack_public_path__ + "static/media/SuicideSelfHarm.cdd8dc2f.svg";